
// La foto scelta col clic e quella di partenza, per card. WeakMap e non attributi nel DOM: quando
// una card sparisce con filtri o paginazione, la voce se ne va da sola.
const scelta = new WeakMap();
const partenza = new WeakMap();
// Come stava la card prima che la toccassimo: senza questo, srcset/sizes tolti non tornano piu'
// e la foto resta inchiodata a un URL di larghezza fissa (sgranata su retina o dopo un resize),
// mentre le <source> mobile restano riscritte con l'immagine desktop.
const originale = new WeakMap();

function ricorda(card, foto) {
  if (originale.has(card)) return;
  originale.set(card, {
    srcset: foto.getAttribute('srcset'),
    sizes: foto.getAttribute('sizes'),
    src: foto.getAttribute('src'),
    sorgenti: [...(foto.parentElement?.querySelectorAll('source') ?? [])].map((s) => [s, s.getAttribute('srcset')]),
  });
}

function rimetti(card, foto) {
  const prima = originale.get(card);
  if (!prima) return;
  for (const [attributo, valore] of [['srcset', prima.srcset], ['sizes', prima.sizes], ['src', prima.src]]) {
    if (valore === null) foto.removeAttribute(attributo);
    else foto.setAttribute(attributo, valore);
  }
  for (const [sorgente, valore] of prima.sorgenti) {
    if (valore === null) sorgente.removeAttribute('srcset');
    else sorgente.setAttribute('srcset', valore);
  }
}

function mostraFoto(card, url) {
  const foto = card?.querySelector('.product-card__img');
  if (!foto || !url) return null;

  const precedente = foto.currentSrc || foto.src;
  if (!partenza.has(card)) partenza.set(card, precedente);
  ricorda(card, foto);

  if (url === partenza.get(card)) {
    // si torna al colore di partenza: si rimette la card com'era, con tutte le sue sorgenti
    rimetti(card, foto);
    card.classList.remove('is-colore-scelto');
    return precedente;
  }

  foto.removeAttribute('srcset');
  foto.removeAttribute('sizes');
  foto.src = url;

  for (const sorgente of foto.parentElement?.querySelectorAll('source') ?? []) {
    sorgente.srcset = url;
  }

  card.classList.add('is-colore-scelto');

  return precedente;
}

document.addEventListener('click', (evento) => {
  const pallino = evento.target.closest('[data-card-swatch]');
  if (!pallino) return;

  const card = pallino.closest('.product-card');
  if (!card?.querySelector('.product-card__img')) return;

  evento.preventDefault();

  mostraFoto(card, pallino.dataset.cardSwatch);
  scelta.set(card, pallino.dataset.cardSwatch);

  for (const altro of card.querySelectorAll('[data-card-swatch]')) {
    altro.classList.toggle('is-active', altro === pallino);
    altro.setAttribute('aria-pressed', altro === pallino ? 'true' : 'false');
  }
});

// mouseover e mouseout, non enter e leave: questi ultimi non risalgono, e qui serve un solo
// ascoltatore per tutto il documento.
document.addEventListener('mouseover', (evento) => {
  const pallino = evento.target.closest('[data-card-swatch]');
  if (!pallino) return;

  const card = pallino.closest('.product-card');
  if (!card) return;

  if (!scelta.has(card)) {
    const attuale = card.querySelector('.product-card__img');
    if (attuale) scelta.set(card, attuale.currentSrc || attuale.src);
  }

  mostraFoto(card, pallino.dataset.cardSwatch);
});

document.addEventListener('mouseout', (evento) => {
  const dentro = evento.target.closest('[data-card-swatch], .product-card__swatches');
  if (!dentro) return;

  const card = dentro.closest('.product-card');
  if (!card) return;

  const verso = evento.relatedTarget?.closest?.('[data-card-swatch], .product-card__swatches');
  if (verso && verso.closest('.product-card') === card) return;

  mostraFoto(card, scelta.get(card));
});
